import { render, staticRenderFns } from "./AuditLogGroupMetadata.vue?vue&type=template&id=0cf8c430&scoped=true"
import script from "./AuditLogGroupMetadata.vue?vue&type=script&lang=js"
export * from "./AuditLogGroupMetadata.vue?vue&type=script&lang=js"
import style0 from "./AuditLogGroupMetadata.vue?vue&type=style&index=0&id=0cf8c430&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf8c430",
  null
  
)

export default component.exports